import React from "react";

import "./Password.scss";
import Utility from "../../foundation/Utility";

interface PasswordProps {
    id?: string;
    value: any;
    width?: number | string;
    className?: string;
    fullWidth?: boolean;
    style?: React.CSSProperties;
    disabled?: boolean;
    readonly?: boolean;
    autoComplete?: string;
    tooltip?: string;
    tooltipPlace?: string;
    onChange?: (value: string) => void;
    onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
    onKeyUp?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
    onKeyDownCapture?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
    onKeyUpCapture?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
}

interface PasswordState {
    ref: React.RefObject<HTMLInputElement>;
    visible: boolean;
    value?: string;
}

class Password extends React.Component<PasswordProps, PasswordState> {
    state = {
        ref: React.createRef<HTMLInputElement>(),
        visible: false,
    } as PasswordState;

    componentDidMount(): void {
        let value = Utility.notNull(this.props.value)
            ? String(this.props.value)
            : this.props.value;
        this.setState({ value: value });
    }

    componentDidUpdate(prevProps: Readonly<PasswordProps>): void {
        if (prevProps.value !== this.props.value) {
            let value = Utility.notNull(this.props.value)
                ? String(this.props.value)
                : this.props.value;
            this.setState({ value: value });
        }
    }

    onFocus() {
        setTimeout(() => this.state.ref.current?.select(), 100);
    }

    changed(value: string) {
        this.props.onChange?.(value);
    }

    render(): React.ReactNode {
        let classes = `passwordbox`;
        if (this.props.className) classes += ` ${this.props.className}`;

        let inputClasses = "";
        if (this.props.fullWidth) inputClasses += " full";

        return (
            <label
                className={classes}
                style={{ width: this.props.width }}
                data-html={true}
                data-tip={this.props.tooltip}
                data-place={this.props.tooltipPlace}>
                <input
                    id={this.props.id}
                    ref={this.state.ref}
                    className={inputClasses}
                    type={this.state.visible ? "text" : "password"}
                    value={this.state.value ?? ""}
                    autoComplete={this.props.autoComplete ?? "new-password"}
                    disabled={this.props.disabled === true}
                    readOnly={this.props.readonly === true}
                    onFocus={this.onFocus.bind(this)}
                    onChange={ev => this.changed(ev.target.value)}
                    onKeyDown={this.props.onKeyDown}
                    onKeyUp={this.props.onKeyUp}
                />

                <button
                    data-tip={
                        this.state.visible ? "Hide password" : "Show password"
                    }
                    data-place="bottom"
                    onClick={() =>
                        this.setState(() => ({ visible: !this.state.visible }))
                    }>
                    <i>
                        {this.state.visible ? "visibility" : "visibility_off"}
                    </i>
                </button>
            </label>
        );
    }
}

export default Password;
